<div class="container-fluid p-0">
  <div class="row g-0 flex-nowrap">
    <div class="col-auto d-xl-flex d-none">
      <div id="sidebar" class="collapse show">
        <div id="sidebar-menu" tabindex="-1" aria-labelledby="sidebar-menu-label">
          <div class=" d-md-flex flex-column custom-side-bar">
            <ul class="nav flex-column">
              <li class="nav-item d-flex justify-content-center p-2 text-centerc">
                <a class="navbar-brand d-none d-md-flex">
                  <img src="/assets/images/logo_acfs.png" alt="Logo" class="">
                  <h6 class="text-logo my-auto">
                    ระบบตามสอบสินค้าเกษตร
                    บนระบบคลาวด์<br>
                    (QR Trace on Cloud)
                  </h6>
                </a>
              </li>
            </ul>
            <span class="custom-hr"><hr></span>
            <ng-container [ngTemplateOutlet]="sidebarContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto d-md-flex d-xl-none">
      <div id="sidebar-md" #sideBarMd class="collapse">
        <div id="sidebar-menu-md" tabindex="-1" aria-labelledby="sidebar-menu-label">
          <div class="row">
            <div class="col-11 ps-5 mt-3">
              <a class="navbar-brand d-flex d-xl-none">
                <img src="/assets/images/logo_acfs.png" alt="Logo" style="width: 50px;">
                <h6 class="text-logo my-auto">
                  ระบบตามสอบสินค้าเกษตร บนระบบคลาวด์ (QR Trace on Cloud)
                </h6>
              </a>
            </div>
            <div class="col-1 align-content-center text-end pe-5">
              <a data-bs-toggle="collapse"
                 data-bs-target="#sidebar-md"
                 aria-controls="sidebar-md"
                 aria-expanded="true"
                 aria-label="Toggle navigation">
                <i class="bi bi-x" style="font-size: 2.65rem;color: red;font-weight: bold"></i>
              </a>
            </div>
            <span class="custom-hr-md"><hr class="m-2"></span>
              <ng-container [ngTemplateOutlet]="sidebarContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col content-flex" style="">
      <header id="header">
        <nav class="navbar navbar-expand">
          <div class="container-fluid">
            <button class="navbar-toggler d-xl-block d-none border-0"
                    type="button" data-bs-toggle="collapse"
                    data-bs-target="#sidebar"
                    aria-controls="sidebar"
                    aria-expanded="true"
                    aria-label="Toggle navigation">
              <i class="bi bi-list custom-icon-list"></i>
            </button>
            <button class="navbar-toggler d-xl-none d-block border-0"
                    type="button" data-bs-toggle="collapse"
                    data-bs-target="#sidebar-md"
                    aria-controls="sidebar-md"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
              <i class="bi bi-list custom-icon-list"></i>
            </button>
            @if (isTestEnv()) {
              <div class="ms-auto me-2">
                <div class="d-flex flex-wrap align-items-center justify-content-center gap-2">
                  <h4 class="text-danger">- เครื่องนี้ใช้สำหรับทดสอบ -</h4>
                </div>
              </div>
            }

              <div class="ms-auto me-2">
                <div class="d-flex flex-wrap align-items-center justify-content-end gap-2">
                    <!-- แบบสอบถามความพึงพอใจ - ซ่อนในหน้าจอเล็กมาก -->
                    <div class="d-none d-sm-block" *hasAnyRole="['user','user_admin']">
                      <button type="button"
                              class="btn btn-light btn-sm btn-sm-block px-2 py-1"
                              (click)="feedBackModal()">
                        <span class="d-none d-md-inline">แบบสอบถาม<br>ความพึงพอใจในการใช้บริการ</span>
                        <span class="d-inline d-md-none">แบบสอบถาม</span>
                      </button>
                    </div>

                  <!-- ชื่อผู้ใช้ - ปรับขนาดตามหน้าจอ -->
                  <div class="text-end d-none d-sm-block">
                  <span class="fw-medium text-truncate" style="display: inline-block;">
                    {{ userData?.name }}
                  </span>
                  </div>

                  <!-- Dropdown โปรไฟล์ -->
                  <div class="dropdown">
                    <a class="dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="bi-person-circle" style="font-size: 1.8rem; color: #2AC195"></i>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li> <span class=" dropdown-item fw-medium text-truncate" style="display: inline-block;">{{ userData?.name }}</span></li>
                      <li>
                        <hr class="dropdown-divider">
                      </li>
                      <li><a class="dropdown-item" [href]="environment.accountInfoUrl"><i class="bi bi-person me-2"></i>โปรไฟล์</a></li>
                      <li>
                        <hr class="dropdown-divider">
                      </li>
                      <!-- แสดงแบบสอบถามในเมนูสำหรับหน้าจอเล็ก -->
                      <li class="d-block d-sm-none" *hasAnyRole="['user','user_admin']">
                        <a class="dropdown-item" (click)="feedBackModal()"><i class="bi bi-emoji-smile me-2"></i>แบบสอบถาม</a>
                      </li>
                      <li><a class="dropdown-item" (click)="logout()"><i class="bi bi-box-arrow-in-right me-2"></i>ออกจากระบบ</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </nav>
      </header>
      <div id="content">
        <app-header></app-header>
        <router-outlet></router-outlet>
        <app-loading id="loading"></app-loading>
      </div>
    </div>
  </div>
</div>
  <ng-template #sidebarContent>
      <div id="sidebar-content">
        <ul class="nav flex-column mt-1" customNavCollapse *hasAnyRole="['user','user_admin']">
          <li class="nav-item">
            <a routerLink="/manufacturer" routerLinkActive="active"
               data-bs-toggle="collapse"
               data-bs-target="#sidebar-md"
               aria-controls="sidebar-md"
               aria-expanded="true"
               aria-label="Toggle navigation"
               class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
              <i class="bi bi-person-fill"></i>
              ข้อมูลผู้ประกอบการ
            </a>
          </li>
        </ul>
        <ul class="nav flex-column" customNavCollapse>
          @if (manufacturerRest?.manufacturer?.businessType && manufacturerRest?.manufacturer?.businessType !== 'FARMER') {
            <li class="nav-item" *hasAnyRole="['user','user_admin']">
              <a routerLink="/manager" routerLinkActive="active"
                 data-bs-toggle="collapse"
                 data-bs-target="#sidebar-md"
                 aria-controls="sidebar-md"
                 aria-expanded="true"
                 aria-label="Toggle navigation"
                 class="nav-link btn d-flex align-items-center align-middle  border-0 gap-2">
                <i class="bi bi-people-fill"></i>
                จัดการผู้ใช้งานในกลุ่ม/บริษัท
              </a>
            </li>
          } @else if (manufacturerRest?.manufacturer?.businessType && manufacturerRest?.manufacturer?.businessType === 'FARMER') {
            <li class="nav-item" *hasAnyRole="['user','user_admin']">
              <a routerLink="/manager/farmer" routerLinkActive="active"
                 data-bs-toggle="collapse"
                 data-bs-target="#sidebar-md"
                 aria-controls="sidebar-md"
                 aria-expanded="true"
                 aria-label="Toggle navigation"
                 class="nav-link btn d-flex align-items-center align-middle  border-0 gap-2">
                <i class="bi bi-people-fill"></i>
                จัดการผู้ใช้งาน
              </a>
            </li>
          }
          @if (manufacturerRest?.manufacturer?.businessType) {
            <app-sidebar-menu *hasAnyRole="['user','user_admin']" routerActiveUrl="/master/general"
                              name="ข้อมูลหลัก (Master Data)" icons="bi bi-database">
              <app-sidebar-menu-item menuLink="/master/general" name="ข้อมูลทะเบียนทั่วไป"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/master/production" name="ข้อมูลทะเบียนการผลิต"></app-sidebar-menu-item>
            </app-sidebar-menu>
          }
          @if (manufacturerRest?.manufacturer?.businessType) {
            <app-sidebar-menu *hasAnyRole="['user','user_admin']" routerActiveUrl="/form" [routerActiveOnClick]="true"
                              name="แบบฟอร์ม สร้าง QR Code" icons="bi bi-file-earmark-text-fill">
              <app-sidebar-menu-item menuLink="/form/plant" name="ผัก/ผลไม้"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/rice" name="ข้าว"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/egg" name="ไข่"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/fishing" name="ประมง"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/livestock" name="ปศุสัตว์"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/processed" name="อาหารแปรรูป"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/herbs" name="สมุนไพร"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/processed-other"
                                     name="ผลิตภัณฑ์แปรรูปอื่น (ที่ไม่ใช่อาหาร)"></app-sidebar-menu-item>
              <app-sidebar-menu-item menuLink="/form/restaurant" name="เมนูอาหาร"></app-sidebar-menu-item>
            </app-sidebar-menu>
          }
          <li class="nav-item" *hasAnyRole="['admin']">
            <a routerLink="/user-official" routerLinkActive="active"
               data-bs-toggle="collapse"
               data-bs-target="#sidebar-md"
               aria-controls="sidebar-md"
               aria-expanded="true"
               aria-label="Toggle navigation"
               class="nav-link btn d-flex align-items-center align-middle border-0 gap-2">
              <i class="bi bi-person-gear"></i>
              จัดการผู้ใช้งานระบบ (เจ้าหน้าที่)
            </a>
          </li>
          <li class="nav-item" *hasAnyRole="['admin','official']">
            <a routerLink="/qrcode" routerLinkActive="active"
               data-bs-toggle="collapse"
               data-bs-target="#sidebar-md"
               aria-controls="sidebar-md"
               aria-expanded="true"
               aria-label="Toggle navigation"
               class="nav-link btn d-flex align-items-center align-middle  border-0 gap-2">
              <i class="bi bi-qr-code"></i>
              การจัดการ QR Code
            </a>
          </li>
          <li class="nav-item" *hasAnyRole="['admin']">
            <a routerLink="/feedback" routerLinkActive="active"
               data-bs-toggle="collapse"
               data-bs-target="#sidebar-md"
               aria-controls="sidebar-md"
               aria-expanded="true"
               aria-label="Toggle navigation"
               class="nav-link btn d-flex align-items-center align-middle  border-0 gap-2">
              <i class="bi bi-emoji-smile-fill"></i>
              รายงานแบบสอบถามความพึงพอใจ
            </a>
          </li>
          @if (manufacturerRest?.manufacturer?.businessType || officialOrAdmin) {
            <app-sidebar-menu routerActiveUrl="/report/all" name="รายงาน" icons="bi bi-graph-up">
              <app-sidebar-menu-item menuLink="/report/all" name="รายงานทั้งหมด"></app-sidebar-menu-item>
              <app-sidebar-menu-item *hasAnyRole="['admin','official']" menuLink="/report/dashboard"
                                     name="Dashboard"></app-sidebar-menu-item>
            </app-sidebar-menu>
          }
          <app-sidebar-menu *hasAnyRole="['admin']" routerActiveUrl="/admin/user" name="การจัดการข้อมูล"
                            icons="bi bi-file-earmark-text-fill">
            <app-sidebar-menu-item menuLink="/admin/user" name="จัดการผู้ใช้งานระบบ"></app-sidebar-menu-item>
            <app-sidebar-menu-item menuLink="/admin/qrcode" name="จัดการการหมดอายุ QR Code"></app-sidebar-menu-item>
            <app-sidebar-menu-item menuLink="/admin/register-group"
                                   name="จัดการข้อมูลทะเบียนกลุ่มวัตถุดิบ"></app-sidebar-menu-item>
          </app-sidebar-menu>
          @if (manufacturerRest?.manufacturer?.businessType && !(manufacturerRest?.manufacturer?.businessType == 'FARMER' || manufacturerRest?.manufacturer?.businessType == 'FARMER_GROUP' || manufacturerRest?.manufacturer?.businessType == 'COOPERATIVE' || manufacturerRest?.manufacturer?.businessType == 'COMMUNITY')) {
            <li class="nav-item mb-5" *hasAnyRole="['user','user_admin']">
              <a routerLink="/search" routerLinkActive="active"
                 data-bs-toggle="collapse"
                 data-bs-target="#sidebar-md"
                 aria-controls="sidebar-md"
                 aria-expanded="true"
                 aria-label="Toggle navigation"
                 class="nav-link btn d-flex align-items-center align-middle  border-0 gap-2">
                <i class="bi bi-pc-display-horizontal"></i>
                ค้นหาวัตถุดิบ
              </a>
            </li>
          }
          <li class="nav-item  mb-5" *hasAnyRole="['admin']">
            <a href="{{ environment.monitoringUrl }}"
               class="nav-link btn d-flex align-items-center align-middle  border-0 gap-2">
              <i class="bi bi-activity"></i>
              ประสิทธิภาพการทำงาน
            </a>
          </li>
        </ul>
      </div>
  </ng-template>

<app-toasts></app-toasts>
